// Shared option lists for the extended candidate profile.
export const YEARS_EXPERIENCE = ["0–3", "4–7", "8–12", "13–20", "20+"];

export const SENIORITY_LEVELS = [
  "Manager", "Senior Manager", "Director", "Senior Director",
  "VP", "SVP", "C-Suite", "Founder", "Board Member", "Advisor",
];

export const DESIRED_ROLES = [
  "CEO", "COO", "CTO", "Chief Product Officer", "VP Product", "VP Engineering",
  "Executive Director", "Managing Director", "Head of Innovation", "General Manager",
  "Venture Partner", "Entrepreneur in Residence", "Board Member", "Fractional Executive",
];

export const SKILLS = [
  "AI", "Fintech", "Climate Tech", "Healthcare", "Cybersecurity", "Sales", "GTM",
  "Fundraising", "Product", "Engineering", "Operations", "Marketing", "HR",
  "Manufacturing", "Energy", "Deep Tech",
];

export const COMPANY_STAGES = [
  "Pre-seed", "Seed", "Series A", "Series B", "Growth", "Public Company",
  "Nonprofit", "Venture Fund", "Accelerator", "University", "Corporate Innovation",
];

export const COMPANY_TYPES = [
  "Startup", "VC", "Family Office", "PE-backed", "Corporate", "Government",
  "Nonprofit", "University", "Accelerator", "Economic Development",
];

export const COMPENSATION_RANGES = [
  "$70–100k", "$100–150k", "$150–200k", "$200–250k", "$250–350k", "$350k+",
];

export const REMOTE_PREFERENCES = ["Remote Only", "Hybrid", "On-site", "Open to Any"];

export const RELOCATE_OPTIONS = ["Yes", "No", "Depends"];

export const WORK_AUTH_OPTIONS = [
  "US Citizen", "Permanent Resident", "Visa Sponsorship Required", "Other",
];

export const TRAVEL_OPTIONS = ["None", "25%", "50%", "75%"];

export const NOTABLE_ACHIEVEMENTS = [
  "Raised $50M+", "IPO", "Built product to 1M users", "Led acquisition",
  "Exited founder", "Managed 500-person team",
];

export const BOARD_TYPES = ["Public", "Private", "Nonprofit", "Advisory"];

export const LANGUAGES = [
  "English", "Spanish", "French", "German", "Mandarin", "Hindi",
  "Portuguese", "Arabic", "Japanese", "Italian",
];

export const SOCIAL_LINKS = [
  { key: "x", label: "X / Twitter", placeholder: "https://x.com/…" },
  { key: "github", label: "GitHub", placeholder: "https://github.com/…" },
  { key: "medium", label: "Medium", placeholder: "https://medium.com/@…" },
  { key: "personal", label: "Personal site", placeholder: "https://…" },
];
